import { render, staticRenderFns } from "./my-business-maintain-orders.vue?vue&type=template&id=cafeb812"
import script from "./my-business-maintain-orders.vue?vue&type=script&lang=js"
export * from "./my-business-maintain-orders.vue?vue&type=script&lang=js"
import style0 from "./my-business-maintain-orders.vue?vue&type=style&index=0&id=cafeb812&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports